import { getReachablePathToPosition } from '../../utils/getReachablePath/index.js';
import hasLosFromPosition from '../../utils/hasLosFromPosition.js';
import { AttackType } from '@wareena/grid-battles-entity/game/codebook/attackTypes';
import positionToStringId from '../../utils/positionToStringId.js';
import { isSamePosition } from '@wareena/game-algorithms';
export default function rankMapByProximityToEnemy({ dangerousEnemyUnits, gameState, agentSide, hexes, hexProperties, rules, }) {
    const rankedPositionsById = {};
    const enemyUnits = gameState.units.filter((u) => u.side !== agentSide);
    const isDangerous = (unitId) => dangerousEnemyUnits.find((u) => u.id === unitId) !== undefined;
    hexes.forEach((hex) => {
        const stringId = positionToStringId(hex);
        rankedPositionsById[stringId] = {
            ...hex,
            rank: 0,
        };
        enemyUnits.forEach((enemyUnit) => {
            if (isSamePosition(hex, enemyUnit.position)) {
                rankedPositionsById[stringId].rank += enemyUnit.maxMovementPoints * 6;
                return;
            }
            if (!isDangerous(enemyUnit.id)) {
                return;
            }
            const distance = hexProperties.getDistance(enemyUnit.position, hex);
            if (enemyUnit.attackType === AttackType.Melee) {
                if (distance > enemyUnit.maxMovementPoints + 1) {
                    return;
                }
                if (distance === 1) {
                    rankedPositionsById[stringId].rank += enemyUnit.maxMovementPoints + 1;
                }
                else {
                    const path = getReachablePathToPosition(enemyUnit, enemyUnit.maxMovementPoints, hex, hexProperties, rules, gameState.units.filter((u) => u.side === enemyUnit.side), hexes);
                    if (path && path.length) {
                        rankedPositionsById[stringId].rank +=
                            enemyUnit.maxMovementPoints - path.length + 1;
                    }
                }
            }
            else if (enemyUnit.attackType === AttackType.Ranged) {
                if (distance > enemyUnit.range) {
                    return;
                }
                const hasLos = hasLosFromPosition({
                    range: enemyUnit.range,
                    fromPosition: enemyUnit.position,
                    targetPosition: hex,
                    allUnits: gameState.units,
                    hexProperties,
                    rules,
                });
                const losFactor = hasLos ? 1 : 0.5;
                rankedPositionsById[stringId].rank += Math.max(0, losFactor * (enemyUnit.range - distance + 1));
            }
        });
    });
    return rankedPositionsById;
}
